import(/* webpackMode: "eager" */ "/app/app/components/pages/product/ProductPagination.js")